module.exports = __webpack_public_path__ + "img/internet-explorer.6154a4d3.svg";